//
export const ACCOUNT_MEMBER_INVITE_SET_PARAMS = 'ACCOUNT_MEMBER_INVITE_SET_PARAMS';
export const ACCOUNT_MEMBER_INVITE_RESET = 'ACCOUNT_MEMBER_INVITE_RESET';
export const ACCOUNT_MEMBER_INVITE = 'ACCOUNT_MEMBER_INVITE';
export const ACCOUNT_MEMBER_INVITE_SUCCESS = 'ACCOUNT_MEMBER_INVITE_SUCCESS';
export const ACCOUNT_MEMBER_INVITE_FAIL = 'ACCOUNT_MEMBER_INVITE_FAIL';
